export const PLASMIC_T01_QUERY_KEY = "plasmic-t01-testimonial-data";

export const T01_TABLE_ID = "t01";

export const CMS_SECTION_FIELDS = {
  TESTIMONIAL: "testimonial",
} as const;

export const TESTIMONIAL_FIELDS = {
  COMPANY_LOGO: "Company Logo",
  COMPANY_LOGO_ALT: "Company Logo Alt",
  COMPANY_NAME: "Company Name",
  TESTIMONIAL_CONTENT: "Testimonial Content",
  AUTHOR_AVATAR: "Author Avatar",
  AUTHOR_AVATAR_ALT: "Author Avatar Alt",
  AUTHOR_NAME: "Author Name",
  AUTHOR_DESIGNATION: "Author Designation",
} as const;

export interface T01TestimonialItem {
  [TESTIMONIAL_FIELDS.COMPANY_LOGO]?: {
    url: string;
    name?: string;
    imageMeta?: { width: number; height: number };
  };
  [TESTIMONIAL_FIELDS.COMPANY_LOGO_ALT]?: string;
  [TESTIMONIAL_FIELDS.COMPANY_NAME]?: string;
  [TESTIMONIAL_FIELDS.TESTIMONIAL_CONTENT]?: string;
  [TESTIMONIAL_FIELDS.AUTHOR_AVATAR]?: {
    url: string;
    name?: string;
  };
  [TESTIMONIAL_FIELDS.AUTHOR_AVATAR_ALT]?: string;
  [TESTIMONIAL_FIELDS.AUTHOR_NAME]?: string;
  [TESTIMONIAL_FIELDS.AUTHOR_DESIGNATION]?: string;
}
